import * as React from "react";
import { SimpleForm, TextInput, Create, CreateProps } from "react-admin";

export const CreateStatus: React.FC<CreateProps> = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" fullWidth required label="Nombre" />
      </SimpleForm>
    </Create>
  );
};
